import { MenuDataForRole, MenuItemType } from "../models/menuItem";
import { AppUserRoles } from "./constants";

const SuperAdminItems: MenuItemType[] = [
  { displayName: "Dashboard", id: "dashboard" },
  {
    displayName: "Admin Panel",
    id: "admin-panel",
    children: [
      { displayName: "Company", id: "company" },
      { displayName: "Users", id: "users" },
    ],
  },
  { displayName: "Insurance List", id: "insurance" },
  { displayName: "Task List", id: "task-list" },
  { displayName: "Reports", id: "report" },
  { displayName: "Settings", id: "settings" },
  { displayName: "Data Exchange", id: "dataExchange" },
  { displayName: "HHA Config", id: "hhaConfig" },
];

const AdminItems: MenuItemType[] = [
  { displayName: "Dashboard", id: "dashboard" },
  { displayName: "Reports", id: "report" },
  { displayName: "CareGiver List", id: "caregiver" },
  { displayName: "Patient List", id: "patient" },
  { displayName: "Appointments", id: "appointment" },
  { displayName: "Task List", id: "task-list" },
  { displayName: "Invoice", id: "invoice" },
  {
    displayName: "Finance",
    id: "finance",
    children: [
      { displayName: "Patient", id: "financePatient" },
      { displayName: "Caregiver", id: "financeCaregiver" },
    ],
  },
  { displayName: "Settings", id: "settings" },
  {
    displayName: "Billing",
    id: "billing",
    children: [
      { displayName: "Payment Methods", id: "paymentMethod" },
      { displayName: "Invoices", id: "billingInvoice" },
    ],
  },
  { displayName: "Import", id: "import" },
  { displayName: "Data Exchange", id: "dataExchange" },
  { displayName: "HHA Config", id: "hhaConfig" },
];

export const ConfigMenuData: MenuDataForRole = {
  [AppUserRoles.SuperAdmin as string]: SuperAdminItems,
  [AppUserRoles.Admin as string]: AdminItems,
};
